import { CallIntelTypes } from '@frontend/api-call-intel';
import { i18next } from '@frontend/i18n';
import { FieldMapping } from './call-analysis-util';

export const DEFAULT_FIELD_EMPTY_VALUE = '-';

export const FIELD_MAPPING: FieldMapping = {
  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_APPOINTMENT_TYPE]: {
    type: 'appointmentTypes',
    emptyValue: DEFAULT_FIELD_EMPTY_VALUE,
    dependentAnalysis: [],
    label: i18next.t('Appointment Type', {
      ns: 'analytics',
    }),
    optionType: 'appointmentTypes',
    suggestion: {
      title: i18next.t('Suggest an Appointment Type', {
        ns: 'analytics',
      }),
      description: i18next.t(
        'Please suggest an Appointment Type that would best fit this call and our Call Intelligence team will review it. Thank you!',
        {
          ns: 'analytics',
        }
      ),
    },
  },
  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_CATEGORY]: {
    type: 'categories',
    emptyValue: DEFAULT_FIELD_EMPTY_VALUE,
    dependentAnalysis: [],
    label: i18next.t('Category', {
      ns: 'analytics',
    }),
    optionType: 'categories',
    suggestion: {
      title: i18next.t('Suggest a Category', {
        ns: 'analytics',
      }),
      description: i18next.t(
        'Please suggest a Category that would best fit this call and our Call Intelligence team will review it. Thank you!',
        {
          ns: 'analytics',
        }
      ),
    },
  },
  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_CONTACT_TYPE]: {
    type: 'contactType',
    emptyValue: DEFAULT_FIELD_EMPTY_VALUE,
    dependentAnalysis: [],
    label: i18next.t('Contact Type', {
      ns: 'analytics',
    }),
    optionType: 'contactType',
  },
  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_SCHEDULING_OPPORTUNITY]: {
    type: 'schedulingOpportunity',
    emptyValue: DEFAULT_FIELD_EMPTY_VALUE,
    dependentAnalysis: [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_SCHEDULING_OUTCOME],
    label: i18next.t('Scheduling Opportunity', {
      ns: 'analytics',
    }),
    optionType: 'schedulingOpportunity',
  },
  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_SCHEDULING_OUTCOME]: {
    type: 'schedulingOutcome',
    emptyValue: i18next.t('N/A', {
      ns: 'analytics',
    }),
    dependentAnalysis: [],
    label: i18next.t('Scheduling Outcome', {
      ns: 'analytics',
    }),
    optionType: 'schedulingOutcome',
  },

  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_SCHEDULING_OUTCOME_V2]: {
    type: 'schedulingOutcomeV2',
    emptyValue: DEFAULT_FIELD_EMPTY_VALUE,
    dependentAnalysis: [],
    label: i18next.t('Scheduling Outcome', {
      ns: 'analytics',
    }),
    optionType: 'schedulingOutcomeV2',
  },
  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_SENTIMENT]: {
    type: 'callSentiment',
    emptyValue: DEFAULT_FIELD_EMPTY_VALUE,
    dependentAnalysis: [],
    label: i18next.t('Customer Sentiment', {
      ns: 'analytics',
    }),
    optionType: 'sentiment',
  },
  [CallIntelTypes.AnalysisTypeEnum.ANALYSIS_TYPE_SERVICE_QUALITY_V2]: {
    type: 'serviceQualityFlags',
    emptyValue: DEFAULT_FIELD_EMPTY_VALUE,
    dependentAnalysis: [],
    label: i18next.t('Service Issues', {
      ns: 'analytics',
    }),
    optionType: 'serviceQualityFlag',
    suggestion: {
      title: i18next.t('Suggest a Service Issue', {
        ns: 'analytics',
      }),
      description: i18next.t(
        'Please suggest a Service Issue that would best fit this call and our Call Intelligence team will review it. Thank you!',
        {
          ns: 'analytics',
        }
      ),
    },
  },
};

export const LOCAL_STORAGE_KEYS = {
  CALL_INTEL_UNSAVED_CHANGES_MODAL_PREF: 'CALL_INTEL_UNSAVED_CHANGES_MODAL_PREF',
};
